module.exports = __webpack_public_path__ + "static/media/20180522-LCS-006-4.8cab1155.jpg";